// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"39":"6e38135b","184":"9c35ce8c","795":"9c35ce8c"}[chunkId] + ".css";
};